import axios from "axios";
import { kaya, building } from "../../api";

const apiUrl = kaya;

const q = (boundaryId) => (boundaryId ? `?boundary_id=${boundaryId}` : "");

// Drill-down statistics dashboard (totals + per-child breakdown) for a level.
// No boundaryId = national (Zanzibar).
export function loadStatisticsDashboard(boundaryId) {
  return axios.get(`${building}/statistics/dashboard${q(boundaryId)}`);
}

export function loadMemberEducationReport(boundaryId) {
  return axios.get(`${apiUrl}/kaya/member/report/education${q(boundaryId)}`);
}

export function loadMemberPopulationReport(boundaryId) {
  return axios.get(`${apiUrl}/kaya/member/report/population${q(boundaryId)}`);
}

// Vital Statistical Report: population by age, households, residences, migration.
export function loadVitalReport(boundaryId) {
  return axios.get(`${apiUrl}/kaya/member/report/vital${q(boundaryId)}`);
}

export function loadMemberSummaryReport(boundaryId) {
  return axios.get(`${apiUrl}/kaya/member/report/summary${q(boundaryId)}`);
}
